import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import LoadingOverlay from "react-loading-overlay";
import PropTypes from "prop-types";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";

const BilateralLoanLogHistory = ({...props}) => {
    return (
        <LoadingOverlay active={props.isLoading} spinner text='Cargando...'>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={10}>
                        <TitlePage title={"Bilaterales \\ Tablero de Control \\ Bitácora \\ Folio: "
                            + props.loanId}/>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            label="Cerrar"
                            style={{'float': 'right'}}
                            onClick={props.closeButton}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                        <br/>
                        <SubtitleLabel header="Transacciones" isBold={true}/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.loanHistory}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="actionDateTime"
                                header="Fecha y Hora"
                                style={{textAlign: 'left', width: '15%'}}
                                sortable={true}
                            />
                            <Column
                                field="loanId"
                                header="Folio del Préstamo"
                                style={{textAlign: 'left', width: '15%'}}
                                sortable={true}
                            />
                            <Column
                                field="status"
                                header="Estatus"
                                style={{textAlign: 'left', width: '15%'}}
                                sortable={true}
                            />
                            <Column
                                field="description"
                                header="Descripción"
                                style={{textAlign: 'left'}}
                                sortable={true}
                            />
                            <Column
                                field="user"
                                header="Usuario"
                                style={{textAlign: 'left', width: '15%'}}
                                sortable={true}
                            />
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </LoadingOverlay>
    )
};

export default BilateralLoanLogHistory;

BilateralLoanLogHistory.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
    closeButton: PropTypes.func.isRequired,
    loanId: PropTypes.number,
    loanHistory: PropTypes.array
};